/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import type { PropsWithSessionLabel } from 'bundles/course-sessions/utils/withSessionLabel';
import withSessionLabel from 'bundles/course-sessions/utils/withSessionLabel';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import type OnDemandLearnerSession from 'bundles/naptimejs/resources/onDemandLearnerSessions.v1';

import _t from 'i18n!nls/ondemand';

type PropsFromCaller = {
  courseHomeLink: string;
  courseName: string;
  // courseId is passed to the HOC withSessionLabel
  courseId: string;
  enrolledSession: OnDemandLearnerSession;
  isSelfServeSession: boolean;
  id: string;
};

type PropsToComponent = PropsWithSessionLabel<PropsFromCaller>;

const style = {
  headerText: css`
    font-size: var(--cds-font-size-300);
  `,
};

export const SessionSwitchSuccess = (props: PropsToComponent) => {
  const { sessionLabel, courseHomeLink, enrolledSession, courseName, isSelfServeSession, id } = props;

  const getTitleText = () => {
    return _t("You've joined the {sessionDates} schedule for {courseName}.");
  };

  return (
    <div className="rc-SessionSwitchSuccess">
      <Typography2 component="h2" css={style.headerText} id={id}>
        {_t('Success!')}
      </Typography2>

      <div className="content">
        <p className="body-1-text">
          <FormattedHTMLMessage
            message={getTitleText()}
            sessionDates={enrolledSession.dateRangeString}
            courseName={courseName}
          />
        </p>
        <p className="body-1-text">
          {!enrolledSession.hasStarted &&
            (sessionLabel === 'session'
              ? _t(
                  `You can access lectures, readings, and all Week 1 materials now, and you’ll have access to all
              materials on your new session start date. `
                )
              : _t(
                  `You can access lectures, readings, and all Week 1 materials now, and you’ll have access to all
                materials on your new schedule start date. `
                ))}
          {!isSelfServeSession &&
            (sessionLabel === 'session'
              ? _t(
                  `Any assignment grades you’ve received will transfer to your new session. Remember to re-submit
            ungraded submissions and other drafts in your new session to receive a grade. `
                )
              : _t(
                  `Any assignment grades you’ve received will transfer to your new schedule. Remember to re-submit
            ungraded submissions and other drafts in your new schedule to receive a grade. `
                ))}
        </p>
      </div>
      <div className="horizontal-box align-items-right wrap">
        <a className="link-button primary" href={courseHomeLink}>
          {_t('View Course')}
        </a>
      </div>
    </div>
  );
};

export default withSessionLabel<PropsFromCaller>(SessionSwitchSuccess);
